<script lang="ts">
import { VNode } from 'vue';
import { defineComponent, PropType } from 'vue-demi';
import PinItem from './PinItem.vue';

export default defineComponent({
  name: 'PinBoard',
  props: {
    pinItemIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    dataKey: {
      type: String,
      default: 'id',
    },
  },
  methods: {
    /* Children should have an ID (or similar) property */
    getIdFromTarget(target: VNode): string {
      return (target.data?.props || {})[this.dataKey]
        || (target.data?.attrs || {})[this.dataKey]
        || (target.elm as HTMLElement)?.getAttribute(this.dataKey);
    },

    isEmptySlot(slot: VNode) {
      return !slot.tag && !slot.text?.trim();
    },
  },
  render(this: any, h) {
    const items: VNode[] = this.$slots.default || [];

    /* Wrap each child in a slot in a pinnable item */
    const pinItems = items
      .filter(slot => !this.isEmptySlot(slot))
      .map(slot => {
        const isPinned = !!this.pinItemIds.find((itemId: string) => {
          return itemId == this.getIdFromTarget(slot);
        });

        return h(PinItem, { props: { isPinned } }, [slot]);
      });

    return h('div', { class: ['pin-board'] }, pinItems);
  },
});
</script>

<style lang="scss" scoped>
.pin-board {
  display: flex;
  flex-direction: column;
}
</style>
